module.exports = __webpack_public_path__ + "media/images/pic/lectors/iga-strzalka-da14b46df7041f2417f1243207c9d7f1.jpeg";